import React from "react";
import { MantineProvider } from "@mantine/core";
import { BrowserRouter } from "react-router-dom";

export default function Layout({ children }) {
  return (
    <BrowserRouter>
      <MantineProvider
        theme={{
          breakpoints: {
            xs: "30em",
            sm: "240px", // Small screens and up
            md: "568px", // Medium screens and up
            lg: "1160px", // Large screens and up
            xl: "1280px", // Extra-large screens and up
            "2xl": "1736px", // 2XL screens and up
          },
        }}
      >
        {children}
      </MantineProvider>
    </BrowserRouter>
  );
}
